import { render, staticRenderFns } from "./役員借入.vue?vue&type=template&id=1bf6377c&scoped=true&"
import script from "./役員借入.ts?vue&type=script&lang=ts&"
export * from "./役員借入.ts?vue&type=script&lang=ts&"
import style0 from "./役員借入.css?vue&type=style&index=0&id=1bf6377c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf6377c",
  null
  
)

export default component.exports